<div style="margin-left: 24px; margin-right: 24px">


<div class="container col-lg-12 mb-3">
    <div class="d-flex justify-content-between align-items-center">
        <h5 class="mb-0" style="font-size: 15px; color: #2F2B3DE5">Intégration</h5>
        <button class="btn btn-primary" (click)="openAjoutModal()"  >+ Ajouter</button>
    </div>
</div>


<ngb-alert [type]="'warning'" [dismissible]="false">

    <div class="alert-body">
        Générez un jeton API sécurisé pour intégrer harmonieusement votre application WordPress, PrestaShop ou personnalisée à notre
        puissante plateforme. Suivez notre guide étape par étape simple pour activer une communication robuste et débloquer des fonctionnalités avancées.
        Pour des instructions complètes et une assistance, visitez notre portail d'intégration sur
    </div>
</ngb-alert>
</div>

<app-ajout-integration #ajoutIntegration></app-ajout-integration>